import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import type { SupportedLanguage } from "./types";
import { SUPPORTED_LANGUAGES } from "./types";

export function useAppTranslation(ns?: string | string[]) {
  const { t, i18n, ready } = useTranslation(ns);

  const currentLanguage = i18n.language as SupportedLanguage;

  const changeLanguage = (lang: SupportedLanguage) => {
    i18n.changeLanguage(lang);
  };

  const formatDate = useCallback(
    (date: Date, options?: Intl.DateTimeFormatOptions): string => {
      return new Intl.DateTimeFormat(i18n.language, options).format(date);
    },
    [i18n.language],
  );

  const formatNumber = useCallback(
    (value: number, options?: Intl.NumberFormatOptions): string => {
      return new Intl.NumberFormat(i18n.language, options).format(value);
    },
    [i18n.language],
  );

  const formatCurrency = useCallback(
    (value: number, currency: string, options?: Intl.NumberFormatOptions): string => {
      return new Intl.NumberFormat(i18n.language, {
        style: "currency",
        currency,
        ...options,
      }).format(value);
    },
    [i18n.language],
  );

  return {
    t,
    i18n,
    ready,
    currentLanguage,
    changeLanguage,
    supportedLanguages: SUPPORTED_LANGUAGES,
    formatDate,
    formatNumber,
    formatCurrency,
  };
}
